var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "j-modal",
    {
      staticClass: "j-super-query-modal",
      staticStyle: { top: "5%", "max-height": "95%" },
      attrs: {
        title: "家长联系方式",
        width: 600,
        visible: _vm.visible,
        mask: true,
        fullscreen: _vm.izMobile,
        footer: null,
      },
      on: { cancel: _vm.handleCancel },
    },
    _vm._l(_vm.detailList, function (item, index) {
      return _c("div", { key: index, staticClass: "list-item" }, [
        _c("div", [_vm._v(_vm._s(item.realname) + "手机：")]),
        _c("div", { staticStyle: { "font-weight": "bold" } }, [
          _vm._v(_vm._s(item.phone)),
        ]),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }